import { createActions, createReducer } from 'reduxsauce'

import ArquivosAnexosService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosPlanosAnuaisContratacoesInicio: [],
    buscaArquivosPlanosAnuaisContratacoesSucesso: ['arquivosPlanosAnuaisContratacoes'],
    buscaArquivosPlanosAnuaisContratacoesErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosPlanosAnuaisContratacoes = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosPlanosAnuaisContratacoesInicio())
        let serv = new ArquivosAnexosService()
        return serv
            .consultarAnexosPlanosAnuaisContratacoes(filtro)
            .then(response => dispatch(Creators.buscaArquivosPlanosAnuaisContratacoesSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosPlanosAnuaisContratacoesErro(error)))
    }
}

const buscaArquivosPlanosAnuaisContratacoesInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaArquivosPlanosAnuaisContratacoesErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosPlanosAnuaisContratacoesSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosPlanosAnuaisContratacoes, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_PLANOS_ANUAIS_CONTRATACOES_INICIO]: buscaArquivosPlanosAnuaisContratacoesInicio,
    [Types.BUSCA_ARQUIVOS_PLANOS_ANUAIS_CONTRATACOES_ERRO]: buscaArquivosPlanosAnuaisContratacoesErro,
    [Types.BUSCA_ARQUIVOS_PLANOS_ANUAIS_CONTRATACOES_SUCESSO]: buscaArquivosPlanosAnuaisContratacoesSucesso,
})
